// ProfilePage.js
import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import '../src/profilepagestyle.css';
import { useHistory } from 'react-router-dom';  

import { toast , ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BaseAPI from "./api/apiurl"



const ProfilePageUser = () => {
  const [profileData, setProfileData] = useState(null);
  const [password, setPassword] = useState(null);
  const [userid, setUserId] = useState(null);
  const [customername, setCustomername] = useState(localStorage.getItem('customername'));
  const [uniqid , setUniqid] = useState(localStorage.getItem('id'));


  const history = useHistory();

  const handelcancel = () => {
    const modules = JSON.parse(localStorage.getItem('modules'));
    const isProjectModuleEnabled = modules.some(module => module.P === 1);
    const isServiceDashboardModuleEnabled = modules.some(module => module.S === 1);
  
    const areBothModulesEnabled = isProjectModuleEnabled && isServiceDashboardModuleEnabled;
  
    let redirectRoute = '/fallbackRoute'; // Default fallback route
  
    if (areBothModulesEnabled) {
      redirectRoute = '/timeinlive/dashboard';
    } else if (isProjectModuleEnabled) {
      redirectRoute = '/timeinlive/dashboard';
    } else if (isServiceDashboardModuleEnabled) {
      redirectRoute = '/timeinlive/serviceDashboard';
    }
  
    history.push(redirectRoute); 
  };


    const handleSubmit = async (e) => {
      e.preventDefault();
      const parsedId = parseInt(uniqid); 
      const requestData = {
        id: parsedId,
        password: password
      };
      console.log("password values" , userid , password);

      try {
        const response = await fetch(`${BaseAPI}userupdate`, {
          method: 'POST',
          mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Headers': 'Content-Type,X-Amz-Date,Authorization,X-Api-Key,X-Amz-Security-Token',
          'Access-Control-Allow-Methods': 'OPTIONS,POST',
          'Access-Control-Allow-Credentials': true,
          'Access-Control-Allow-Origin': '*',
          'X-Requested-With': '*',
        },
          body: JSON.stringify(requestData)
        });
        if (response.ok) {
          // Handle successful response
          toast.success('Update Successful', {
            autoClose: 1500,
            position: 'top-center',
            className: 'custom-toast-success', // Apply the custom error class
});
await new Promise((resolve) => setTimeout(resolve, 1500));

// Navigate to the desired route
history.push('/timeinlive');

       
          console.log('Update successful');
        } else {
          toast.error('password invalid', {
            autoClose: 1500,
            position: 'top-center',
            className: 'custom-toast-error', // Apply the custom error class
          });
        }
      } catch (error) {
        console.error('Error:', error);
      console.error('Response:', await error.response.json()); // Log the response from the server
      console.error('Error response:', error.response);

      }
    };

  console.log("varutha" ,uniqid)
  

  useEffect(() => {
    // Get the user ID from localStorage
    const userid = localStorage.getItem('id');

    console.log('userId:', userid);

    if (userid) {
      // Construct the API URL with the user ID
      const apiUrl = `${BaseAPI}uprofile?id=${userid}`;
      setUserId(userid);
      // Fetch data from the API
      fetch(apiUrl)
        .then(response => response.json())
        .then(data => {
          setProfileData(data.data); // Update to use the "data" property of the response
        })
        .catch(error => {
          console.error('Error fetching data:', error);
        });
    }
  }, []);     

  console.log("valus" , profileData);
  

  return (
    <Container>
     
      <Row className="justify-content-center mt-5">
        <Col md={6}>
          <div className="profile-card">
            <h2 className="text-center mb-4">Edit Profile</h2>
            <Form onSubmit={handleSubmit}>
            {profileData && (
                <div>
              <Form.Group controlId="customerName">
                <Form.Label>Customer Name</Form.Label>
                <Form.Control type="text" placeholder="Enter customer name" defaultValue={customername} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="role">
                <Form.Label>Role</Form.Label>
                <Form.Control type="text" placeholder="Enter role"  defaultValue={profileData.roleid} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="username">
                <Form.Label>Username</Form.Label>
                <Form.Control type="text" placeholder="Enter username" defaultValue={profileData.username} disabled/>
              </Form.Group>
              &nbsp; &nbsp;
              <Form.Group controlId="password">
                <Form.Label>Password (only change password)</Form.Label>
                <Form.Control type="text" placeholder={profileData.password} value={password} onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
             &nbsp; &nbsp;
             <div  className="d-flex justify-content-center">
              <Button variant="primary" type="submit" className="btn btn-primary">
                Change
              </Button>  &nbsp; &nbsp;
              <Button variant="primary" className="btn btn-primary" onClick={handelcancel}>
                Cancel
              </Button>
              </div>
              </div>
              )}
            </Form>
          </div>
        </Col>
      </Row>
      <ToastContainer />
      <br></br><br></br><br></br>
    </Container>
    
  );
};

export default ProfilePageUser;
